import Route from "../utils/route.js"
import CONFIG from "../utils/config.js"
import Search from "../api/model/search/index.js"
import Util from "../utils/util.js"
var {column} = globalData
var isSelf = false//判断是否在搜索页面
var routeQuery = Route.getQueryObject()
var previewId = routeQuery["previewId"]
var matchingConditionOptions = routeQuery["matchingConditionOptions"]
matchingConditionOptions=Number(matchingConditionOptions?matchingConditionOptions:1)
var sortOrderOptions = routeQuery["sortOrderOptions"]//0 進行時間倒序搜索 2 進行相關度搜索
sortOrderOptions=Number(sortOrderOptions?sortOrderOptions:0)
var storyType = routeQuery["storyType"]
storyType=Number(storyType?storyType:0)
var preColumnIdG = routeQuery["preColumnId"]//上一栏目的columnId目前用来做今日大公点击日历搜索
var searchKeyword = routeQuery["searchKeyword"]
//searchKeyword = searchKeyword?decodeURI(searchKeyword):""//中文解码
var keywordWay = routeQuery["keywordWay"]
keywordWay = keywordWay?keywordWay:0
var $searchMore = ""//显示更多按钮选择器
var $loadMore = ""//加載中选择器
var $noData = ""//缺省图选择器
var page = 0//分页
const size = 8
var dateVal = routeQuery["dateVal"]//日期
var includeSubColumn = routeQuery["includeSubColumn"]
var $searchNumber = ""
var $searchList = ""
var $searchMenuBox = ""
const noMoreText = "已經没有更多";
//加载数据
async function searchStory(){
    if(searchKeyword == null || searchKeyword == "undefined" || searchKeyword == ""){
        return null;
    }
    var channelId = "tkww,takungpao"
    var staticUrl = CONFIG.BASE_STATIC_URL;// 用来显示默认图片的
    $searchMore.css("display","none")
    $loadMore.css("display","block")
    var res = await Search.storyList({
        channelId,
        searchKeyword,
        sortOrderOptions,
        matchingConditionOptions,
        storyType,
        keywordWay,
        page,
        size
    })
    if(Util.isNull(res))return $noData.css("display","block")
    $searchNumber.html(`找到全部<span class='result-sum-inner'>${res.data.totalElements}</span>条結果`).show()
    $searchMenuBox.css("background-color","rgba(0,0,0,0)")
    $(".search-menu-unit:first-of-type,.result-sum").css("margin-left","0")
    let resData = res.data.content
    for(var i=0;i<resData.length;i++){
        var html = ""
        var tubUrl = resData[i].thumbnails != undefined && resData[i].thumbnails.length > 0?resData[i].thumbnails[0].url + "?x-oss-process=image/resize,w_400":resData[i].properties.bookId != undefined? staticUrl+'column/searchResult/epaper/'+resData[i].properties.bookId+'.jpg':staticUrl + 'index-HKTKWW/story-img-default.png';
        html += '<div class="story-list-unit">'
        html += '  <div class="story-list-unit-inner">'
        html += '    <div class="story-list-unit-top">'
        html += '      <div class="img-box-box">'
        html += '        <a class="img-box" rel="noopener norefferrer" title="'+ resData[i].title +'" href="'+ resData[i].url +'">'
        html += '          <img class="img-box-filter" src="'+ tubUrl +'" title="'+ resData[i].title +'" alt="'+ resData[i].title +'">'
        html += '          <img class="img-box-img" src="'+ tubUrl +'" title="'+ resData[i].title +'" alt="'+ resData[i].title +'">'
        html += '        </a>'
        html += '      </div>'
        html += '    </div>'
        html += '    <div class="story-list-unit-content">'
        html += '      <a class="story-list-unit-title twoLine" rel="noopener norefferrer" href="'+ resData[i].url +'" title="'+ resData[i].title +'">'+ resData[i].title +'</a>'
        html += '      <a class="story-list-unit-text threeLine" rel="noopener norefferrer" href="'+ resData[i].url +'" title="'+ resData[i].summary +'">'+ resData[i].summary +'</a>'
        html += '      <div class="story-list-unit-bottom">'
        /*let tagStr = resData[i].tags?resData[i].tags.join(","):""
        if(tagStr!==""){
          html += '        <div class="common-column-list-unit-bottom-tag" onclick="tagsClick(this)">'+tagStr+'</div>'
        }*/
        html += '       <span class="story-list-unit-bottom-time">'
        html +='          <span class="story-list-unit-bottom-time1">'+Util.getEndTimeArr({fmt:'YYYY.mm.dd HH:MM',publishTime:resData[i].publishTime})[0]+'</span>'+(Util.getEndTimeArr({fmt:'YYYY.mm.dd HH:MM',publishTime:resData[i].publishTime}).length>1?(' <span class="story-list-unit-bottom-time2">'+Util.getEndTimeArr({fmt:'YYYY.mm.dd HH:MM',publishTime:resData[i].publishTime})[1]+'</span>'):'')
        html +='        </span>'
        html += '      </div>'
        html += '    </div>'
        html += '  </div>'
        html += '</div>'
        let $html = $(html)
        var oldText ="";
        var newText="";
        //添加标题 26字符长度（英文56字符）
        newText = oldText = resData[i].highlightTitle;
        if (oldText.replace(/[^\x00-\xff]/g, "00").length > 52) {
            newText = oldText;
        }
        newText = showKey(newText,searchKeyword);//红色高亮
        $html.find(".story-list-unit-title").html(newText);
        //添加摘要 50字符长度（英文100字符）
        // 没有高亮content的时候显示摘要
        newText = oldText = "..." + resData[i].highlightContent +"...";
        if(resData[i].highlightContent===''){
            newText = oldText = "..." + resData[i].summary +"...";
        }
        if (oldText.replace(/[^\x00-\xff]/g, "00").length > 110) {
            // newText = oldText.substring(0,50)+"...";
            newText = oldText;
        }
        newText = showKey(newText,searchKeyword);//高亮
        $html.find(".story-list-unit-text").html(newText)
        $searchList.append($html);
    }
    //写入分页
    page++
    $searchMore.css("display","flex")
    $loadMore.css("display","none")
    if(page >= res.data.totalPages ){
        $loadMore.text(noMoreText);
        $loadMore.css("display","block")
        $searchMore.css("display","none")
    }
    if(resData.length){
        $searchList.css("display","flex")
    }
    if(resData.length==0&&page==1){
        $noData.css("display","block")
        $searchMore.css("display","none")
        $loadMore.css("display","none")
    }
}
//红色高亮
function showKey(allStr,keyStr){
    if(keyStr == "" || keyStr == "undefined" || keyStr==null){
        return allStr;
    }
    var reg=new RegExp("("+keyStr+")","g");
    var newstr=allStr.replace(reg,"<font color=#C21010>$1</font>");
    return newstr;
}
//加载更多
window.searchStoryMore = function(){
    if($searchMore.text()===noMoreText)return
    if(!dateVal){
        searchStory()
    }else{
        searchStroyByDate()
    }
}

//搜索按钮触发的事件
const searchStoryBut = function({
                                     inputStr="",
                                     isBlank=true,
                                     blankUseMatching=false,
                                     isCi=true,
                                     dateVal="",
                                     includeSubColumn,
                                     preColumnId
                                 }){
    var searchColumnId = $(".searchColumnId").eq(0).attr("value")
    var searchColumnName = $(".searchColumnName").eq(0).attr("value")
    var searchColumnFileName = $(".searchColumnFileName").eq(0).attr("value")
    var searchColumnFilePath = $(".searchColumnFilePath").eq(0).attr("value")
    var openUrl = previewId?`${window.location.origin}/template/preview/channels/tkww/columns/${searchColumnId}?previewId=${previewId.replace(/^([^/]+\/[^/]+\/).*$/,("$1"+searchColumnFilePath))}&fileName=${searchColumnFileName}`:`${CONFIG.BASE_URL}${searchColumnName}`//判断本地环境还是线上环境，确定将跳转的路径
    // 新CI埋点
    var searchInput = inputStr?$(`${inputStr}`).val():searchKeyword
    if(isCi&&searchInput)mini_paq.push(["eventSearch", "search_keyword", searchInput,{}])
    //searchInput = encodeURI(searchInput)
    openUrl += `${previewId?'&':'?'}searchKeyword=${searchInput}&keywordWay=${keywordWay}`
    if(dateVal){
        openUrl += `&dateVal=${dateVal}&includeSubColumn=${includeSubColumn}&preColumnId=${isBlank?preColumnId:preColumnIdG}`
    }
    if(isBlank){
        if(blankUseMatching){
            openUrl += `&matchingConditionOptions=${matchingConditionOptions}`
            openUrl += `&sortOrderOptions=${sortOrderOptions}`
        }
        if(window.top.location.href.indexOf("/canyou")===-1){
            window.open(openUrl,"_blank")
        }else{
            window.location.href=openUrl
        }
        return
    }
    openUrl += `&matchingConditionOptions=${matchingConditionOptions}`
    if(sortOrderOptions)openUrl += `&sortOrderOptions=${sortOrderOptions}`
    if(storyType)openUrl += `&storyType=${storyType}`
    if(page)openUrl += `&page=${page}`
    window.location.href = openUrl
}

//内容页点击标签触发的事件
const searchKeywords = function(e,incomingMatchingConditionOptions=2){
    searchKeyword = $(e).text();
    keywordWay = 1
    matchingConditionOptions = incomingMatchingConditionOptions
    searchStoryBut({isCi:false,blankUseMatching:true})
    // 新CI埋点
    mini_paq.push(["eventSearch", "search_tag", searchKeyword,{}])
}

//内容页点击标签触发的事件
window.searchTags = function(e,i){
    var aa = $(".key_word");
    searchKeyword = $(aa[i]).text();
    keywordWay = 1
    searchStoryBut({isCi:false})
    // 新CI埋点
    mini_paq.push(["eventSearch", "search_tag", searchKeyword,{}]);
}

//毫秒转成 2018-09-20 20:00:00
function getDate(str) {
    var oDate = new Date(str),
        oYear = oDate.getFullYear(),
        oMonth = oDate.getMonth()+1,
        oDay = oDate.getDate(),
        oHour = oDate.getHours(),
        oMin = oDate.getMinutes(),
        oSen = oDate.getSeconds(),
        oTime = addZero(oMonth) +'-'+ addZero(oDay) +' '+ addZero(oHour) +':'+ addZero(oMin) +':'+addZero(oSen);
    return oTime;
}
function dateFormat(fmt, str) {
    var date = new Date(str.replace(/-/g, '/').replace('T', ' ').replace('.000+0000', '') + ' GMT');
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            //fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")));
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (pad(opt[k],ret[1].length)));
        };
    };
    return fmt;
}
//补零操作
function addZero(num){
    if(parseInt(num) < 10){
        num = '0'+num;
    }
    return num;
}

//初始化“匹配条件”浮动
function initCondition({unitClass,options}){
    //如果有传路由参数
    var $unitClass = $(`.${unitClass}`)
    if(options){
        for(let i = 0;i < $unitClass.length;i++){
            var $unitClassEq = $unitClass.eq(i)
            if($unitClassEq.attr("value")==options){
                $unitClassEq.addClass(`${unitClass}-active`)//选中样式
                return
            }
        }
    }
    //如果没有传路由参数
    $unitClass.eq(0).addClass(`${unitClass}-active`)//选中样式
}
//设置搜索条件
window.searchConfigChange = function({target,changeName}){
    var data = {isBlank:false,isCi:false,inputStr:"#search-body-input"}
    switch(changeName){
        case "matchingConditionOptions":{
            matchingConditionOptions = Number($(target).attr("value"))
            break;
        }
        case "storyType":{
            storyType = Number($(target).attr("value"))
            break;
        }
        case "sortOrderOptions":{
            sortOrderOptions = Number($(target).attr("value"))
            break;
        }
    }
    if(dateVal){
        data.dateVal = dateVal
        data.includeSubColumn = includeSubColumn
    }
    searchStoryBut(data)
}
//查询某个栏目下某天的稿件
async function searchStroyByDate(){
    var channelId = "takungpao"
    var staticUrl = CONFIG.BASE_STATIC_URL;// 用来显示默认图片的
    $searchMenuBox.css("background-color","rgba(0,0,0,0)")
    $searchMore.css("display","none")
    $loadMore.css("display","block")
    var res = await Search.dateStoryList({channelId,columnId:preColumnIdG,dateVal,page,includeSubColumn,sortOrderOptions,size})
    if(Util.isNull(res))return $noData.css("display","block")
    let resData = res.data
    // 写入数据
    for(var i=0;i<resData.length;i++){
        var html = ""
        var tubUrl = resData[i].thumbnails != undefined && resData[i].thumbnails.length > 0?resData[i].thumbnails[0].url + "?x-oss-process=image/resize,w_400":resData[i].properties.bookId != undefined? staticUrl+'column/searchResult/epaper/'+resData[i].properties.bookId+'.jpg':staticUrl + 'index-HKTKWW/story-img-default.png';
        html += '<div class="story-list-unit">'
        html += '  <div class="story-list-unit-inner">'
        html += '    <div class="story-list-unit-top">'
        html += '      <div class="img-box-box">'
        html += '        <a class="img-box" rel="noopener norefferrer" title="'+ resData[i].title +'" href="'+ resData[i].url +'">'
        html += '          <img class="img-box-filter" src="'+ tubUrl +'" title="'+ resData[i].title +'" alt="'+ resData[i].title +'">'
        html += '          <img class="img-box-img" src="'+ tubUrl +'" title="'+ resData[i].title +'" alt="'+ resData[i].title +'">'
        html += '        </a>'
        html += '      </div>'
        html += '    </div>'
        html += '    <div class="story-list-unit-content">'
        html += '      <a class="story-list-unit-title twoLine" rel="noopener norefferrer" href="'+ resData[i].url +'" title="'+ resData[i].title +'">'+ resData[i].title +'</a>'
        html += '      <a class="story-list-unit-text threeLine" rel="noopener norefferrer" href="'+ resData[i].url +'" title="'+ resData[i].summary +'">'+ resData[i].summary +'</a>'
        html += '      <div class="story-list-unit-bottom">'
        /*let tagStr = resData[i].tags?resData[i].tags.join(","):""
        if(tagStr!==""){
          html += '        <div class="common-column-list-unit-bottom-tag" onclick="tagsClick(this)">'+tagStr+'</div>'
        }*/
        html += '       <span class="story-list-unit-bottom-time">'
        html +='          <span class="story-list-unit-bottom-time1">'+Util.getEndTimeArr({fmt:'YYYY.mm.dd HH:MM',publishTime:resData[i].publishTime})[0]+'</span>'+(Util.getEndTimeArr({fmt:'YYYY.mm.dd HH:MM',publishTime:resData[i].publishTime}).length>1?(' <span class="story-list-unit-bottom-time2">'+Util.getEndTimeArr({fmt:'YYYY.mm.dd HH:MM',publishTime:resData[i].publishTime})[1]+'</span>'):'')
        html +='        </span>'
        html += '      </div>'
        html += '    </div>'
        html += '  </div>'
        html += '</div>'

        let $html = $(html)
        var oldText ="";
        var newText="";
        //添加标题 26字符长度（英文56字符）
        newText = oldText = resData[i].title;
        if (oldText.replace(/[^\x00-\xff]/g, "00").length > 52) {
            // newText = oldText.substring(0,26)+"...";
            newText = oldText;
        }
        $html.find(".story-list-unit-title").html(newText);
        //添加摘要 50字符长度（英文100字符）
        newText = oldText = resData[i].summary;
        if (oldText.replace(/[^\x00-\xff]/g, "00").length > 110) {
            // newText = oldText.substring(0,50)+"...";
            newText = oldText;
        }
        $html.find(".story-list-unit-text").html(newText);
        $searchList.append($html);
    }
    page++
    $searchMore.css("display","flex")
    $loadMore.css("display","none")
    if(resData.length == 0){
        $loadMore.text(noMoreText);
        $searchMore.css("display","none")
        $loadMore.css("display","block")
    }
    if(resData.length){
        $searchList.css("display","flex")
    }
    if(resData.length==0&&page==1){
        $noData.css("display","block")
        $searchMore.css("display","none")
        $loadMore.css("display","none")
    }
}
//初始化搜索
function initSearchInput(){
    $('#search-body-input').bind('keydown','#search-body-input', function (event) {
        var event = window.event || arguments.callee.caller.arguments[0];
        //console.log(".search-top-left",event.keyCode,$(this).attr("id"))
        var inputId = $(this).attr("id")
        if (event.keyCode == 13 && inputId == "search-body-input"){
            searchStoryBut({inputStr:"#search-body-input",isBlank:false});
            // $(".header-search .searchbutton").click();
            return;
        }
    });
    $('#search-body-input').focus(function(){
        $('.search-input-box').css("border","solid 1px #e20413")
    })
    $('#search-body-input').blur(function(){
        $('.search-input-box').css("border","0")
    })
}
async function initSearch(){
    $('#hot-words-input-2').css('display','block')
    //$("input[name='keywordWay']").val(0);
    //没有搜索词显示缺省页面
    $searchMore = $(".add-more-v5").eq(0)
    $loadMore = $(".add-more-loading-v5").eq(0)
    $noData = $(".search-no-data").eq(0)
    $searchNumber = $(".result-sum").eq(0)
    $searchList = $("#search-list").eq(0)
    $searchMenuBox = $(".search-menu-box").eq(0)
    initSearchInput()
    //没有日期参数时
    if(!dateVal){
        if(!searchKeyword){
            $noData.css("display","block")
            return
        }
        if(searchKeyword)$("input#search-body-input").val(searchKeyword)
        await searchStory()
    }else{
        //有日期参数时
        //去除不能使用的筛选项目
        /*$(".search-order-tool").eq(0).css("display","none")
                $("#selectedMatchingCondition").parents(".search-order-list-unit").css("display","none")
                $(".date-choose").eq(0).css("display","block")
                $(".search-order").eq(0).css("margin-bottom","20px")*/
        $(".search-menu").eq(0).css("display","none")
        $searchNumber.css("display","none")
        $(".search-input-box").eq(0).css("display","none")
        //加载数据
        await searchStroyByDate()
    }
}
//站点稿件标签点击事件
window.tagsClick = function(e,tag=""){
    searchKeyword = $(e).text();
    //如果读取不到元素标签（可写入文字的标签）的文字，读取元素标签（不可写入文字的标签,如img）的title
    if(searchKeyword===''){
        searchKeyword = $(e).attr("title")
    }
    if(tag!==""){
        searchKeyword = tag
    }
    // 新CI埋点
    mini_paq.push(["eventSearch", "search_tag",searchKeyword,{}])
    keywordWay = "tag"
    /*inputId="",
    isBlank=true,
    blankUseMatching=false,
    isCi=true,
    dateVal="",
    includeSubColumn,
    preColumnId*/
    //let openUrl = previewId?`${window.location.origin}/template/preview/channels/tkww/columns/658e459fe4b05c885816f716?previewId=${previewId}&fileName=column-tag`:`${CONFIG.BASE_URL}tagSearch`//判断本地环境还是线上环境，确定将跳转的路径
    //searchInput = encodeURI(searchInput)
    //openUrl += `${previewId?'&':'?'}tag=${searchKeyword}`
    let openUrl = `${CONFIG.BASE_URL}tagSearch?tag=${searchKeyword}`
    if(window.top.location.href.indexOf("/canyou")===-1){
        window.open(openUrl,"_blank")
    }else{
        window.location.href=openUrl
    }
}
//质朴长存法 by lifesinger
function pad(num, n) {
    var len = num.toString().length;
    while(len < n) {
        num = "0" + num;
        len++;
    }
    return num;
}
//初始化搜索页面
function initSearchResult(){
    if(!isSelf)return
    /*初始化搜全文*/
    initCondition({
        unitClass:"radio-menu-unit",
        options:matchingConditionOptions
    })
    /*初始化类型*/
    initCondition({
        unitClass:"search-menu-unit",
        options:storyType
    })
    initCondition({
        unitClass:"radio-menu-unit1",
        options:sortOrderOptions
    })
    /*searchStoryInitSortOrder()
            typeSearchFn()
            scrooFn()*/
    initSearch()
}
export default {
    searchStoryBut,
    searchKeywords
}